// @ts-nocheck
import React, { useContext, useState, useEffect } from 'react';
import Context from '../../context/Context';
import { URL } from '../../service/Service';
import { useParams } from 'react-router-dom';
import { editFormElement } from '../../context/forms/FormsAction';
import Breadcrumb from '../Breadcrumb';
import Header from '../TitleAndSubtitle';

const DonationEdit = ({ elementInfo }) => {
	const { idform, idformelement } = useParams();
	const { dispatch } = useContext(Context);
	const [label, setLabel] = useState(elementInfo.label || '');
	const [donation, setDonation] = useState(String(elementInfo.donation || ''));
console.log(elementInfo);
	const pages = [
		{
			name: 'Editar Elementos',
			href: `/forms/${idform}/formeditor`,
			current: false
		},
		{
			name: 'Editar Doação',
			href: `/forms/${idform}/formelements/${idformelement}/edit`,
			current: true
		}
	];

	useEffect(() => {
		setLabel(elementInfo.label || '');
		setDonation(String(elementInfo.donation || ''));
	}, [elementInfo]);

	const updateHandler = () => {
		const url = `${URL}/api/forms/${idform}/formelements/${idformelement}`;
		const request = {
			method: 'PATCH',
			headers: {
				'Content-type': 'application/json',
				'Accept': 'application/json',
			},
			body: JSON.stringify({ label, donation }),
		};
		editFormElement(url, request, dispatch);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		updateHandler();
	};

	const handleChange = (e) => {
		let inputValue = e.target.value.replace(/,/g, '.');
		const regex = /^\d*\.?\d{0,2}$/;
		if (regex.test(inputValue) || inputValue === '') {
			setDonation(inputValue);
		}
	};

	return (
		<div className='p-5'>
			<Breadcrumb pages={pages} />
			<div className='mb-5'></div>
			<div className="flex flex-col md:flex-row justify-between items-center">
				<Header title="Editar Doação" />
			</div>

			<form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
				<div className="mb-4">
					<label className="p-2.5 text-sm font-bold text-gray-900">Legenda</label>
					<input
						className="mt-1 w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
						type="text"
						onChange={e => setLabel(e.target.value)}
						value={label}
					/>
				</div>
				<div className="mb-10">
					<label className="p-2.5 text-sm font-bold text-gray-900">Valor sugerido (€)</label>
					<input
						className="mt-1 w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
						type="text"
						onChange={handleChange}
						value={donation.replace('.', ',')}
					/>
				</div>
				<div>
					<button className="mr-4 bg-green-cl hover:bg-opacity-80 text-white py-2 px-4 rounded">
						Guardar
					</button>
				</div>
			</form>
		</div>
	);
};

export default DonationEdit;